<template>
    <v-card class="ma-2 time-card">
        <v-card-text>
            <div class="recording-title">Time Off</div>
            <v-divider class="mb-3"></v-divider>
            <v-form v-model="formValid" ref="form" lazy-validation novalidate>
                <v-layout align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-time-off-btn">
                                {{getTimeOffDuration(this.timeOffStartDate, this.timeOffEndDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="time-off-date" slot="activator" label="Start date" v-model="timeOffStartDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="timeOffStartDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="time-off-date" slot="activator" label="End date" v-model="timeOffEndDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="timeOffEndDate" :allowed-dates="timeOffAllowedDays" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mx-3">
                            <v-text-field :disabled="!isEditEnabled" v-model="timeOffComment" label="Comment"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click.stop.prevent="addNewTimeOff()" slot="activator" class="add-time-off-btn">
                            <v-icon color="indigo">mdi-plus</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <template v-for="timeOff in timeOffDays">
                <v-divider :key="`divider-${timeOff.id ? `id${timeOff.id}` : `obsId${timeOff.observationId}`}`" class="mb-3"></v-divider>
                <v-layout :key="`layout-${timeOff.id ? `id${timeOff.id}` : `obsId${timeOff.observationId}`}`" align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat disabled color="black" class="add-time-off-btn">
                                {{getTimeOffDuration(timeOff.startDate, timeOff.endDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="time-off-date" slot="activator" label="Start date" v-model="timeOff.startDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="timeOff.startDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="mx-3">
                            <v-menu :disabled="!isEditEnabled" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="time-off-date" slot="activator" label="End date" v-model="timeOff.endDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="timeOff.endDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mx-3">
                            <v-text-field :disabled="!isEditEnabled" v-model="timeOff.comment" label="Comment"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="removeExistTimeOff(timeOff)" slot="activator" class="add-time-off-btn">
                            <v-icon color="indigo">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="editExistTimeOff(timeOff, id)" slot="activator" class="add-time-off-btn">
                            <v-icon color="indigo">mdi-content-save</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import moment from 'moment';
    import {
        mapGetters, mapActions
    } from 'vuex';

    export default {
        name: 'EmployeeTimeOff',
        data() {
            return {
                timeOffStartDate: null,
                timeOffEndDate: null,
                timeOffComment: '',
                formValid: false,
                dateRules: [ value => !!value || 'Choose date' ],
                observationId: 0
            };
        },
        computed: {
            ...mapGetters({
                employee: 'getEmployee',
                timeOffDays: 'getAllTimeOff'
            }),
            isEditEnabled() {
                return !this.employee.archived;
            }
        },
        methods: {
            ...mapActions([
                'addTimeOff',
                'editTimeOff',
                'removeTimeOff'
            ]),
            addNewTimeOff() {
                if (this.$refs.form.validate()) {
                    const timeOff = {
                        observationId: this.observationId++,
                        startDate: this.timeOffStartDate,
                        endDate: this.timeOffEndDate,
                        comment: this.timeOffComment,
                        user: {
                            userId: this.employee.userId
                        }
                    };

                    this.addTimeOff(timeOff).then(() => {
                        this.$refs.form.reset();
                    });
                }
            },
            removeExistTimeOff(timeOff) {
                this.removeTimeOff(timeOff);
            },
            editExistTimeOff(timeOff) {
                this.editTimeOff(timeOff);
            },
            timeOffAllowedDays(date) {
                return moment(date).isSameOrAfter(moment(this.timeOffStartDate));
            },
            getTimeOffDuration(startDate, endDate) {
                return !!startDate && !!endDate
                    ? moment.duration(moment(endDate)
                        .diff(moment(startDate))).asDays() + 1
                    : 0;
            }
        }
    };
</script>

<style scoped>
.recording-title {
  font-size: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.add-time-off-btn >>> .btn__content {
  padding: 0;
}

.add-time-off-btn {
  min-width: 32px;
  width: 32px;
  min-height: 32px;
  height: 32px;
  margin: 6px 0px 14px 6px;
  background-color: #ced2e6 !important;
  font-size: 18px;
}

.time-off-date >>> .input-group__input input {
  font-size: 14px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeTimeOff.vue